import styled, { css } from "styled-components";

import { BaseCell } from "@similarweb/pro-logic-components";
import { ShareBarChart } from "@similarweb/ui-components";

export const StyledProgressBarCellWrapper = styled(BaseCell)<{ barHeight?: number; barWidth?: number }>`
    display: flex;

    ${ShareBarChart} {
        height: ${({ barHeight = 8 }) => `${barHeight}px`};
        ${({ barWidth }) =>
            barWidth
                ? css`
                      width: ${barWidth}px;
                  `
                : ""};

        div {
            border-radius: 0;
        }
    }
`;
